<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
            <h2 class="">{{ $t('restaurantCreate.title') }}</h2>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="mb-3">
                <label for="restTitle" class="form-label">{{ $t('restaurantCreate.name') }} <span class="small text-danger">*</span></label>
                <input v-model.trim="newRest.title" type="text" class="form-control" id="restTitle">
              </div>
              <div class="row">
                <div class="col-12 col-xl-6 mb-3">
                  <label for="restRegion" class="form-label">{{ $t('restaurantCreate.region') }}</label>
                  <input v-model.trim="newRest.address_settings.region" type="text" class="form-control" id="restRegion">
                </div>
                <div class="col-12 col-xl-6 mb-3">
                  <label for="restCity" class="form-label">{{ $t('restaurantCreate.city') }} <span class="small text-danger">*</span></label>
                  <input v-model.trim="newRest.address_settings.city" type="text" class="form-control" id="restCity">
                </div>
                <div class="col-12 col-xl-6 mb-3">
                  <label for="restAddress" class="form-label">{{ $t('restaurantCreate.address') }} <span class="small text-danger">*</span></label>
                  <input v-model.trim="newRest.address_settings.address" type="text" class="form-control" id="restAddress">
                </div>
                <div class="col-12 col-xl-6 mb-3">
                  <label for="restPhone" class="form-label">{{ $t('restaurantCreate.phone') }} <span class="small text-danger">*</span></label>
                  <input v-model.trim="newRest.phone" type="text" class="form-control" id="restPhone">
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <p class="mb-2">{{ $t('restaurantCreate.timeWork') }} <span class="small text-danger">*</span></p>
                    <div class="mb-2 form-check">
                      <input v-model="temp.dayAndNight" type="checkbox" class="form-check-input" id="roundTheCheck">
                      <label class="form-check-label" for="roundTheCheck">{{ $t('restaurantCreate.24h') }}</label>
                    </div>
                  </div>
                  <div>
                    <div class="btn-group btn-group-sm" role="group">
                      <input type="radio" class="btn-check" name="btnradio" id="openingTimeSimple" autocomplete="off"
                             v-model="temp.openingTime" value="simple">
                      <label class="btn btn-outline-secondary" for="openingTimeSimple">{{ $t('restaurantCreate.openingTimeSimple') }}</label>
                      <input type="radio" class="btn-check" name="btnradio" id="openingTimeExtended" autocomplete="off"
                             :disabled="this.temp.dayAndNight"
                             v-model="temp.openingTime" value="extended">
                      <label class="btn btn-outline-secondary" for="openingTimeExtended">{{ $t('restaurantCreate.openingTimeExtended') }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="temp.openingTime === 'simple'" class="d-flex gap-2">
                  <div class="flex-fill d-flex gap-2">
                    <span>{{ $t('restaurantCreate.from') }}</span>
                    <input
                        :disabled="temp.dayAndNight"
                        v-model.trim="newRest.opening_time" type="time" class="form-control form-control-sm"
                        id="restOpenTime">
                  </div>
                  <div class="flex-fill d-flex gap-2">
                    <span>{{ $t('restaurantCreate.to') }}</span>
                    <input
                        :disabled="temp.dayAndNight"
                        v-model.trim="newRest.closing_time" type="time" class="form-control form-control-sm"
                        id="restCloseTime">
                  </div>
                </div>
                <div v-else-if="temp.openingTime === 'extended'">
                  <div v-for="(day, key) of this.temp.weeklySchedule" class="d-flex gap-2 mb-1">
                    <span class="col-1">{{ $t(`restaurantCreate.days.${key}`) }}</span>
                    <input v-model.trim="day.opening_time" :id="`weeklySchedule${key}Start`" type="time" class="form-control form-control-sm"> -
                    <input v-model.trim="day.closing_time" :id="`weeklySchedule${key}End`" type="time" class="form-control form-control-sm">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="restCuisine" class="form-label">{{ $t('restaurantCreate.cuisine') }}</label>
                <input v-model.trim="cuisineStr" :placeholder="$t('restaurantCreate.cuisinePlaceholder')" type="text"
                       class="form-control" id="restCuisine">
              </div>
              <div class="mb-3">
                <label for="restDescription" class="form-label">{{ $t('restaurantCreate.restDescription') }} <span class="small text-danger">*</span></label>
                <textarea v-model.trim="newRest.description" class="form-control" id="restDescription" rows="3" aria-describedby="restDescriptionHelp"></textarea>
                <div id="restDescriptionHelp" class="form-text">{{ $t('restaurantCreate.restDescriptionHelp') }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-check form-switch mb-3">
                <input
                    v-model="newRest.is_available"
                    class="form-check-input"
                    type="checkbox" role="switch" id="prodIsAvailable" aria-describedby="prodIsAvailableHelp" checked>
                <label v-if="newRest.is_available" class="form-check-label" for="prodIsAvailable">{{ $t('restaurantCreate.isAvailable') }}</label>
                <label v-else class="form-check-label" for="prodIsAvailable">{{ $t('restaurantCreate.isClose') }}</label>
                <div id="prodIsAvailableHelp" class="form-text">{{ $t('restaurantCreate.isAvailableHelp') }}</div>
              </div>
              <div class="form-check form-switch mb-3">
                <input v-model="newRest.settings.delivery_enabled"
                       class="form-check-input"
                       type="checkbox" role="switch" id="deliveryEnabled" aria-describedby="prodIsAvailableHelp">
                <label class="form-check-label" for="deliveryEnabled">{{ $t('restaurantCreate.deliveryEnabled') }}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input v-model="newRest.settings.takeaway_enabled"
                       class="form-check-input"
                       type="checkbox" role="switch" id="takeawayEnabled" aria-describedby="prodIsAvailableHelp">
                <label class="form-check-label" for="takeawayEnabled">{{ $t('restaurantCreate.takeawayEnabled') }}</label>
              </div>
              <div v-if="deliveryAndTakeawayDisabled" class="alert alert-warning" role="alert">
                {{ $t('restaurantCreate.deliveryAndTakeawayDisabled') }}
              </div>
              <div class="mb-3 pt-2 border-top">
                {{ $t('restaurantCreate.messageAboutPaymentSettings') }}
              </div>
              <div class="mb-3 pt-2 border-top">
                <label for="restCountry" class="form-label">{{ $t('restaurantCreate.country') }} <span
                    class="small text-danger">*</span></label>
                <select v-model="newRest.address_settings.country" id="restCountry" class="form-select">
                  <option disabled value="">{{ $t('restaurantCreate.select') }}</option>
                  <option v-for="(country, number) in temp.countries"
                          :value="country">{{ country }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="restTimeZone" class="form-label">{{ $t('restaurantCreate.timeZone') }} <span class="small text-danger">*</span></label>
                <select v-model="newRest.address_settings.time_zone" id="restTimeZone" class="form-select" aria-describedby="restTimeZoneHelp">
                  <option disabled value="">{{ $t('restaurantCreate.timeZoneSelect') }}</option>
                  <option v-for="(zone, key) in temp.timeZone"
                          :value="zone.name">{{ zone.name }} ({{ zone.offset }})
                  </option>
                </select>
                <div id="restTimeZoneHelp" class="form-text">{{ $t('restaurantCreate.timeZoneHelp') }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-12 text-end">
              <button v-if="this.loader" type="button" class="btn btn-success" disabled>
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <span> {{ $t('restaurantCreate.loading') }}</span>
              </button>
              <button v-else
                  class="btn btn-success"
                  @click="this.createRestaurant"
                  :disabled="!this.disabledBtnSend"
              >{{ $t('restaurantCreate.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMain from '../modules/NavMain'
import MyBreadcrumb from '../modules/Breadcrumb'
import axios from "axios"
import router from "@/router";
import i18n from "@/i18n";
const config = require('@/config')
const countries = require('@/assets/countries.json')

export default {
  name: "RestaurantCreate",
  components: {NavMain, MyBreadcrumb},
  data() {
    return {
      loader: false,
      temp: {
        countries: countries,
        dayAndNight: false,
        timeZone: [{name: '', offset: 0}],
        openingTime: 'simple',
        weeklySchedule: {
          Monday: {opening_time: '00:00', closing_time: '00:00'},
          Tuesday: {opening_time: '00:00', closing_time: '00:00'},
          Wednesday: {opening_time: '00:00', closing_time: '00:00'},
          Thursday: {opening_time: '00:00', closing_time: '00:00'},
          Friday: {opening_time: '00:00', closing_time: '00:00'},
          Saturday: {opening_time: '00:00', closing_time: '00:00'},
          Sunday: {opening_time: '00:00', closing_time: '00:00'}
        }
      },
      cuisineStr: '',
      newRest: {
        title: '',
        address_settings: {
          time_zone: 'Europe/Kaliningrad',
          country: 'Российская Федерация',
          region: '',
          city: '',
          address: ''
        },
        phone: '',
        cuisine: [],
        opening_time: '00:00',
        closing_time: '00:00',
        description: '',
        is_available: true,
        settings: {
          delivery_enabled: true,
          takeaway_enabled: true,
          category_sequence: {},
          payment_online_enabled: false,
          payment_card_enabled: true,
          payment_cash_enabled: false,
          payment_method: '',
          payment_settings: {}
        },
        weekly_schedule: {},
      }
    }
  },
  computed: {
    disabledBtnSend() {
      if (
          this.newRest.title &&
          this.newRest.address_settings.address &&
          this.newRest.opening_time &&
          this.newRest.closing_time &&
          this.newRest.address_settings.time_zone &&
          this.newRest.description
      ) {
        return true
      } else {
        return false
      }
    },
    deliveryAndTakeawayDisabled() {
      if (!this.newRest.settings.delivery_enabled && !this.newRest.settings.takeaway_enabled) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async createRestaurant() {
      this.loader = true
      await this.$store.dispatch('checkIdToken')
      let idToken = this.$store.state.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      if (this.temp.dayAndNight) {
        this.newRest.opening_time = null
        this.newRest.closing_time = null
        this.newRest.weekly_schedule = null
      }
      if (this.temp.openingTime === 'simple') {
        this.clearWeeklySchedule()
        this.newRest.weekly_schedule = null
      }
      if(this.temp.openingTime === 'extended') {
        this.newRest.opening_time = null
        this.newRest.closing_time = null
        this.newRest.weekly_schedule = this.temp.weeklySchedule
      }
      let data = JSON.stringify(this.newRest)
      axios.post(`${config.servUrl}admin/restaurants`, data, axiosHeader)
          .then(response => {
            this.loader = false
            this.$store.dispatch('addNewNotice', {text: i18n.global.t('restaurantCreate.alerts.restaurantCreated')})
            setTimeout(() => {
              router.push({path: '/restaurants'})
            }, 1000)
          })
          .catch(error => {
            this.loader = false
            console.log(error);
            this.$store.dispatch('addNewNotice', {text: error, error: true})
          })
    },
    clearWeeklySchedule() {
      let days = Object.values(this.temp.weeklySchedule)
      days.forEach((e) => {
        e.closing_time = '00:00'
        e.opening_time = '00:00'
      })
    },
    async getTimeZones() {
      await this.$store.dispatch('checkIdToken')
      let idToken = this.$store.state.tokens.idToken;
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'multipart/form-data'}}
      axios.get(`${config.servUrl}admin/timezones/`, axiosHeader)
          .then((response) => {
            this.temp.timeZone = response.data
          })
          .catch(error =>   {
            console.log(error);
            this.$store.dispatch('addNewNotice', {text: error, error: true})
          })
    }
  },
  watch: {
    cuisineStr: {
      handler(str) {
        const newStr = str.replace(/, /gi, ',');
        this.newRest.cuisine = newStr.split(',')
      }
    },
    'temp.dayAndNight'() {
      this.temp.openingTime = 'simple'
    }
  },
  mounted() {
    this.getTimeZones()
  }
}
</script>

<style scoped>

</style>
